
<template>
    <v-container class="" style="padding: 6px;">
        <!-- >>> Resource was chosen: -------------------------------------- -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource !== undefined">
            <!-- >>> Left Side: -------------------------------------------- -->
            <v-col cols="6" md="3">
                <v-card class="pa-2" style="background-color: #fff;" outlined>
                    <table id="customers">
                        <thead>
                            <tr>
                                <th style="background-color: #CB67A0;">
                                    <v-card-title style="text-align: left; font-weight: 600; font-size: 14px; color: #fff;">
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.genLastname }}, {{ get_flights_ResourceDetails_ResourceAskedFor.genFirstName }}</p>
                                        <p>{{ get_flights_ResourceDetails_ResourceAskedFor.contractFunction }} in {{ get_flights_ResourceDetails_ResourceAskedFor.contractBaseStationCode }}, {{ get_flights_ResourceDetails_ResourceAskedFor.comPhone1 }}</p>
                                    </v-card-title>
                                </th>
                            </tr>
                        </thead>
                    </table>
                </v-card>

                <v-card class="pa-2"  style="margin-top: 10px; background-color: #fff;" outlined>
                    <v-card-text>
                        <datetime v-model="startDate" label="Brief Date:" disabled="false" disabledTime="true" ref="startTimer" briefcaller="step1" />
                    </v-card-text>
                </v-card>

                <v-card class="pa-2" min-height="276" style="margin-top: 10px; background-color: #fff;" outlined>
                     <v-card-text style="text-align: left; font-weight: 500; font-size: 16px;">
                        <!-- >>> 'Flights this Day': ------------------------ -->
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length > 0">Flights this Day:</span>
                        <span style="text-align: left; font-weight: 600; font-size: 14px; text-decoration: underline;" v-if="flightsThisDay.length === 0">No Flights this Day:</span>
                        <template v-for="(flight, index) in flightsThisDay">
                            <p style="font-size: 13px; font-weight: 500;" :key="index"><strong>{{ flight.flight }}:</strong> {{ flight.hours }} (LT), {{ flight.leg }}: {{ flight.ft }}h</p>
                        </template>

                        <!-- >>> 'CiCo': ----------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="myFormattedDate_CheckIn"><strong>Check in: </strong>{{ myFormattedDate_CheckIn }}</p>
                        <p style="font-size: 13px; font-weight: 500;" v-if="myFormattedDate_CheckOut"><strong>Check out: </strong>{{ myFormattedDate_CheckOut }}</p>

                        <!-- >>> 'Sectors': -------------------------------- -->
                        <br /><p style="font-size: 13px; font-weight: 500;" v-if="sectorsThisDay !== null"><strong>Sectors: </strong>{{ sectorsThisDay }}</p><br />

                        <!-- >>> 'Total FT/DT': ------------------------------- -->
                        <p style="font-size: 13px; font-weight: 500;">
                            <span v-if="totalFTThisDay !== null"><strong>FT Total: </strong>{{ totalFTThisDay }}, </span>
                            <span v-if="totalDTThisDay !== null"><strong>DT Total: </strong>{{ totalDTThisDay }}</span>
                        </p><br />

                        <!-- >>> 'Total FDP': ------------------------------ -->
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null"><strong>FDP Total: </strong>{{ fdtInfo.formatted_fdt }}</p>
                        <p style="font-size: 13px; font-weight: 500;" v-if="fdtInfo !== null">max {{ fdtInfo.formatted_max_fdt }}h {{ fdtInfo.formatted_max_fdt_extension }}h
                            <span style="float: right;">
                                <div class="led-green" v-if="isRedOrGreen({ semaforo: 'green', calculation: 'totalfdt' }) === 'green'"></div>
                                <div class="led-red" v-if="isRedOrGreen({ semaforo: 'red', calculation: 'totalfdt' }) === 'red'"></div>
                            </span>
                        </p><br />
                    </v-card-text>
                </v-card>
            </v-col>
            <!-- <<< Left Side: -------------------------------------------- -->


            <!-- >>> Right Side: ------------------------------------------- -->
            <v-col cols="12" sm="6" md="9">
                <v-card class="pa-2" min-height="480" style="background-color: #fff;" outlined>
                    <!-- >>> 'Flight Time': -------------------------------- -->
                    <table id="customers">
                        <thead>
                            <tr>
                                <th width="33%">Flight Time:</th>
                                <th width="33%">Status:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Next 28 Days: </strong>{{ ftNext28Days }} / max {{ maxftNext28Days }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'next28days' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'next28days' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Next 12 Months: </strong>{{ ftNext12MOnths }} / max {{ maxftNext12MOnths }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'next12months' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'next12months' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>This Year: </strong>{{ ftCurrentYear }} / max {{ maxftCurrentYear }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'thisyear' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'thisyear' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- >>> 'Duty Time': ---------------------------------- -->
                    <table id="customers">
                        <thead>
                            <tr>
                                <th width="33%">Duty Time:</th>
                                <th width="33%">Status:</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <strong>Next 7 Days: </strong>{{ dtNex7Days }} / max {{ maxdtNex7Days }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'next7daysdt' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'next7daysdt' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Next 14 Days: </strong>{{ dtNex14Days }} / max {{ maxdtNex14Days }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'next14daysdt' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'next14daysdt' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>Next 28 Days: </strong>{{ dtNex28Days }} / max {{ maxxdtNex28Days }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'next28daysdt' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'next28daysdt' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <strong>This Year: </strong>{{ dtCurrentYear }} / max {{ maxdtCurrentYear }}h
                                </td>
                                <td>
                                    <span style="float: left;">
                                        <div class="led-green" v-if="isRedOrGreen_RightSide({ semaforo: 'green', calculation: 'thisyeardt' }) === 'green'"></div>
                                        <div class="led-red" v-if="isRedOrGreen_RightSide({ semaforo: 'red', calculation: 'thisyeardt' }) === 'red'"></div>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <span style="font-size: 12px; font-weight: 500;">Note:</span><span style="font-size: 12pxem; font-weight: 400;"> Config Overview</span>
                </v-card>
            </v-col>
            <!-- <<< Right Side: ------------------------------------------- -->
        </v-row>
        <!-- <<< Resource was chosen: -------------------------------------- -->




        <!-- >>> Resource was not chosen yet: ------------------------------ -->
        <v-row v-if="get_flights_ResourceDetails_ResourceAskedFor.idResource === undefined">
            <v-col cols="12">
                <v-card class="pa-2" style="background-color: #fff;">
                    <v-card-title class="pa-4" style="color: #CB67A0; font-size: 15px; font-weight: 500;">
                        <i style="font-size:20px; color: #A4C2A5;" class="b-fa b-fa-check-circle"></i> Attention: Dear User, first select a resource in the upper area (click checkbox).
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import Vue from 'vue';
    import Datetime from '../../DateTime.vue';
    import { mapGetters, mapActions } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';

    export default {
        name: 'Step1Content',

        /* >>> *************************************************************** / /* Components */
        components : {

            Datetime,

        }, // eo components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                // >>> --------------------------
                yearlyList: {},
                flightsThisDay: [],
                myFormattedDate_CheckIn: null,
                myFormattedDate_CheckOut: null,
                sectorsThisDay: null,
                totalFTThisDay: null,
                totalDTThisDay: null,
                fdtInfo: null,
                // >>> --------------------------
                resourceDutyAddendum: null,
                ftNext28Days: null,
                maxftNext28Days: null,
                ftNext12MOnths: null,
                maxftNext12MOnths: null,
                ftCurrentYear: null,
                maxftCurrentYear: null,
                dtNex7Days: null,
                maxdtNex7Days: null,
                dtNex14Days: null,
                maxdtNex14Days: null,
                dtNex28Days: null,
                maxxdtNex28Days: null,
                dtCurrentYear: null,
                maxdtCurrentYear: null,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch: {

            /******************************************************************* Picker
            * watch::get_flights_CrewDetails_SavedPayload
            *
            * Desc: Monitor/Watch ... 'get_flights_CrewDetails_SavedPayload'.
            * Note:
            *
            */
            get_flights_CrewDetails_SavedPayload(v) {

                let me = this,
                    timestamp = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> watch get_flights_CrewDetails_SavedPayload');
                if (v.date !== undefined) {
                    timestamp = new Date(v.date).setHours(23, 59, 0, 0);
                    this.startDate = new Date(timestamp);
                }

            }, // eo function get_flights_CrewDetails_SavedPayload()


            /******************************************************************* Brief
            * watch::get_flights_BriefDetails_Flights_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Flights_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Flights_ThisDay(v) {

                this.flightsThisDay = v;

            }, // eo function get_flights_BriefDetails_Flights_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_DutyCheckin_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_DutyCheckin_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_DutyCheckin_ThisDay(v) {

                let tmp1 = null,
                    a = null,
                    b = null,
                    checkin_loc  = null;


                // >>> UTC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    this.myFormattedDate_CheckIn = dayjs.utc(v, dayjs.ISO_8601).format('HH:mm') + ' (UT)';
                } else {
                    this.myFormattedDate_CheckIn = 'empty';
                }

                // >>> LOC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    tmp1 = v;
                    a = tmp1.split("T");
                    b = a[1].split(":");
                    checkin_loc = b[0] + ':' + b[1] + ' (LT)';
                    this.myFormattedDate_CheckIn = this.myFormattedDate_CheckIn + ', ' + checkin_loc;
                }

            }, // eo function get_flights_BriefDetails_DutyCheckin_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_DutyCheckout_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_DutyCheckout_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_DutyCheckout_ThisDay(v) {

                let tmp1 = null,
                    a = null,
                    b = null,
                    checkin_loc  = null;


                // >>> UTC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    this.myFormattedDate_CheckOut = dayjs.utc(v, dayjs.ISO_8601).format('HH:mm') + ' (UT)';
                } else {
                    this.myFormattedDate_CheckOut = 'empty';
                }

                // >>> LOC ------------------------ CheckIn/CheckOut
                if (!Vue.prototype.$isEmpty(v)) {
                    tmp1 = v;
                    a = tmp1.split("T");
                    b = a[1].split(":");
                    checkin_loc = b[0] + ':' + b[1] + ' (LT)';
                    this.myFormattedDate_CheckOut = this.myFormattedDate_CheckOut + ', ' + checkin_loc;
                }

            }, // eo function get_flights_BriefDetails_DutyCheckout_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_Sectors_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_Sectors_ThisDay(v) {

                this.sectorsThisDay = v;

            }, // eo function get_flights_BriefDetails_Sectors_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalFT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_TotalFT_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalFT_ThisDay(v) {

                this.totalFTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalFT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_TotalDT_ThisDay
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_Sectors_ThisDay'.
            * Note:
            *
            */
            get_flights_BriefDetails_TotalDT_ThisDay(v) {

                this.totalDTThisDay = v;

            }, // eo function get_flights_BriefDetails_TotalDT_ThisDay()


            /*******************************************************************
            * watch::get_flights_BriefDetails_FlightDutyTime_FdtInfo
            *
            * Desc: Monitor/Watch ... 'get_flights_BriefDetails_FlightDutyTime_FdtInfo'.
            * Note:
            *
            */
            get_flights_BriefDetails_FlightDutyTime_FdtInfo(v) {

                this.fdtInfo = v;

            }, // eo function get_flights_BriefDetails_FlightDutyTime_FdtInfo()


            /******************************************************************* 'Right Side'
            * watch::get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum
            *
            * Desc: Monitor/Watch ... 'get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum'.
            * Note:
            *
            */
            get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum(v) {

                this.resourceDutyAddendum = v;
                // >>> 'Flights thsi Day' -------
                this.ftNext28Days = v && v.ftNext28Days;
                this.maxftNext28Days = v && v.maxftNext28Days;
                this.ftNext12MOnths = v && v.ftNext12MOnths;
                this.maxftNext12MOnths = v && v.maxftNext12MOnths;
                this.ftCurrentYear = v && v.ftCurrentYear;
                this.maxftCurrentYear = v && v.maxftCurrentYear;
                this.dtNex7Days = v && v.dtNex7Days;
                this.maxdtNex7Days = v && v.maxdtNex7Days;
                this.dtNex14Days = v && v.dtNex14Days;
                this.maxdtNex14Days = v && v.maxdtNex14Days;
                this.dtNex28Days = v && v.dtNex28Days;
                this.maxxdtNex28Days = v && v.maxxdtNex28Days;
                this.dtCurrentYear = v && v.dtCurrentYear;
                this.maxdtCurrentYear = v && v.maxdtCurrentYear;

            }, // eo function get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_CrewDetails_SavedPayload',
                'get_flights_ResourceDetails_ResourceAskedFor',
                // ------------------------------
                'get_flights_BriefDetails_Flights_ThisDay',
                'get_flights_BriefDetails_DutyCheckin_ThisDay',
                'get_flights_BriefDetails_DutyCheckout_ThisDay',
                'get_flights_BriefDetails_Sectors_ThisDay',
                'get_flights_BriefDetails_TotalFT_ThisDay',
                'get_flights_BriefDetails_TotalDT_ThisDay',
                'get_flights_BriefDetails_FlightDutyTime_FdtInfo',
                // ------------------------------
                'get_flights_ResourceDetails_FlighTime_ResourceDutyAddendum',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> created');
            eventBus.$on('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> beforeDestroy');
            eventBus.$off('onchangedatepickerbriefcall', this.onChange_DatePickerInBrief);

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_getCrewDetailsResourceBrief_Reload'
            ]),


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_DatePickerInBrief()
            *
            * Desc:
            * Desc:
            *
            * @param {String} value ()
            */
            onChange_DatePickerInBrief: function(values){

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> onChange_DatePickerInBrief');
                if (values.caller === 'step1') {
                    me.actn_call_getCrewDetailsResourceBrief_Reload({ date: values.date });
                }

            }, // eo function onChange_DatePickerInBrief()




            /*******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * isRedOrGreen()
            *
            * Desc: Decide which traffic light. (Left Side)
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen: function(values) {

                let me = this,
                    semaforo = null,
                    times = [],
                    totalFDP = this.fdtInfo.formatted_fdt,
                    formatted_max_fdt = this.fdtInfo.formatted_max_fdt,
                    formatted_max_fdt_extension = this.fdtInfo.formatted_max_fdt_extension,
                    totalFDP_Minutes = null,
                    formatted_max_fdt_Minutes = null,
                    formatted_max_fdt_extension_Minutes = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> isRedOrGreen');
                if (values.calculation === 'totalfdt') {
                    if (totalFDP !== null) {
                        times = totalFDP.split(':');
                        totalFDP_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        times = formatted_max_fdt.split(':');
                        formatted_max_fdt_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        formatted_max_fdt_extension = formatted_max_fdt_extension.substring(1); // CUT + or - Sign
                        times = formatted_max_fdt_extension.split(':');
                        formatted_max_fdt_extension_Minutes = (parseInt(times[0], 10) * 60) + parseInt(times[1], 10);

                        if (totalFDP_Minutes > (formatted_max_fdt_Minutes + formatted_max_fdt_extension_Minutes)) {
                            semaforo = 'red';
                        } else {
                            semaforo = 'green';
                        }
                    }
                }


                return semaforo;

            }, // eo function isRedOrGreen()


            /*******************************************************************
            * isRedOrGreen_RightSide()
            *
            * Desc: Decide which traffic light. (Right Side)
            * Note:
            *
            * @param {Object} values (e.g.: { semaforo: 'red', calculation: '28days' })
            */
            isRedOrGreen_RightSide: function(values) {

                let me = this,
                    semaforo = null,
                    timesSplit = [],
                    timeInMinutes1 = null,
                    timeInMinutes2 = null;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/crewdetails/BottomSheet/Step1Content.vue >>> isRedOrGreen_RightSide');
                // >>> Flight Time --------------
                if (values.calculation === 'next28days') {
                    timesSplit = this.resourceDutyAddendum.ftNext28Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxftNext28Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'next12months') {
                    timesSplit = this.resourceDutyAddendum.ftNext12MOnths.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxftNext12MOnths, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'thisyear') {
                    timesSplit = this.resourceDutyAddendum.ftCurrentYear.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxftCurrentYear, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }


                // >>> Duty Time --------------
                if (values.calculation === 'next7daysdt') {
                    timesSplit = this.resourceDutyAddendum.dtNex7Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxdtNex7Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'next14daysdt') {
                    timesSplit = this.resourceDutyAddendum.dtNex14Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxdtNex14Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'next28daysdt') {
                    timesSplit = this.resourceDutyAddendum.dtNex28Days.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxxdtNex28Days, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }

                if (values.calculation === 'thisyeardt') {
                    timesSplit = this.resourceDutyAddendum.dtCurrentYear.split(':');
                    timeInMinutes1 = (parseInt(timesSplit[0], 10) * 60) + parseInt(timesSplit[1], 10);
                    timeInMinutes2 = parseInt(this.resourceDutyAddendum.maxdtCurrentYear, 10) * 60;

                    if (timeInMinutes1 < timeInMinutes2) {
                        semaforo = 'green';
                    }
                    if (timeInMinutes1 > timeInMinutes2) {
                        semaforo = 'red';
                    }
                }


                return semaforo;

            }, // eo function isRedOrGreen_RightSide()

        }, // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    #customers {
        border-collapse: collapse;
        width: 100%;
    }

    #customers td, #customers th {
        border: 1px solid #ddd;
        padding: 8px;
        font-size: 13px;
    }

    #customers td {
        font-weight: 500 !important;
    }


    #customers tr:nth-child(even){background-color: #f2f2f2;}

    #customers tr:hover {background-color: #ddd;}

    #customers th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #A4C2A5;
        color: white;
        font-size: 14px;
        font-weight: 600 !important;
    }





    table.MyFlightTimeTable {
        background-color: #fff;
        width: 100%;
    }
    table.MyFlightTimeTable td {
        height: 25px;
        width: 31px;
        color: #000;
        font-size: 13px;
        font-weight: 500;
        text-align: center;
    }
    table.MyFlightTimeTable .header_cell {
        background-color: #A4C2A5;
        color: #fff;
    }
    table.MyFlightTimeTable .cell_empty {
        background-color: #CB67A0;
    }
    table.MyFlightTimeTable .cell_with_value {
        background-color: #f3f4f5;
    }



    .led-green {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #A4C2A5;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #89ff00 0 2px 12px; */
    }

    .led-red {
        margin: 0 auto;
        width: 14px;
        height: 14px;
        background-color: #ff0000;
        border-radius: 50%;
        /* box-shadow: rgb(0 0 0 / 20%) 0 -1px 7px 1px, inset #304701 0 -1px 9px, #e82e15 0 2px 12px; */
    }
</style>


<style>
.v-stepper {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
</style>